import { Component, ComponentFactoryResolver, OnInit } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ModalService, ModalSize } from "@cv-invision/core";
import { ICellRendererParams } from "ag-grid-community";
import { ConfirmationService, MessageService } from "primeng/api";
import { QueueModel } from "../../../model/queue.model";
import { QueuesService } from "../../../service/queues.service";
import { lastValueFrom } from "rxjs";
import { QueueEditorDialogComponent } from "../../dialog/queue-editor/queue-editor.dialog.component";
import { DialogService } from "primeng/dynamicdialog";
import { DialogModes, DialogResult } from "../../../enum/dialog.enum";

@Component({
    selector: 'cv-rule-ticket-custom-action-cell',
    templateUrl: './custom-queues-action-cell.component.html',
    styleUrls: ['./custom-queues-action-cell.component.scss']
})
export class CustomQueueActionCellComponent implements ICellRendererAngularComp, OnInit {
    gridApi: any;
    cellValue: any;
    rowData: any;
    isUserTicketManager = false;

    constructor(
        private modalService: ModalService,
        private componentFactoryResolver: ComponentFactoryResolver,
        private confirmationService: ConfirmationService,
        private queueService: QueuesService,
        private messageService: MessageService,
        private dialogService: DialogService
    ) {}

    /**
     * When the component renders, it got the possible value
     * @param params
     */
    agInit(params: ICellRendererParams): void {
        const { data } = params;
        this.rowData = data;
        this.gridApi = params.api;
        this.cellValue = params;
    }

    ngOnInit(): void {
        
    }

    /**
     * Put back the value
     * @param params
     */
    refresh(params: ICellRendererParams): boolean {
        this.cellValue = params;
        this.gridApi.refreshCells();
        return true;
    }

    /**
     * Handles the event to delete a queue.
     * @param queueId - The ID of the queue to delete
     */
    onDeleteQueue(event): void {
        // Call a service or update local state to remove the ruleset
        const queue: QueueModel = this.cellValue?.data ?? new QueueModel();
        this.confirmationService.confirm({
            message: `Are you sure that you want to delete "${
                queue?.name ?? 'Queue with no name set'
            }"?`,
            icon: 'pi pi-exclamation-triangle',
            accept: async () => {
                try {
                    await lastValueFrom(this.queueService.deleteQueue(queue.id));
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: `Queue ${queue?.name} was deleted.`,
                    });
                    this.queueService.refreshQueues();
                } catch (error) {
                    console.error(error);
                }
            },
        });
    }

    /**
     * Handles the process of creating a new queue by opening a dialog.
     */
    onEditQueue(event): void {
        this.dialogService
            .open(QueueEditorDialogComponent, {
                header: 'Edit Queue',
                width: '950px',
                data: {
                    queueData: this.cellValue.data,
                    dialogMode: DialogModes.EDIT
                },
                styleClass: 'queue-editor-dialog',
            })
            .onClose.subscribe(async (dialogFilterResult: any): Promise<void> => {
                if (
                    dialogFilterResult === DialogResult.SUCCESS
                ) {
                   this.queueService.refreshQueues();
                }
            });
    }
}